import * as ko from "knockout";
import {nsForm} from "../../nsForm";
import {nsDynamicVariable} from "../../../dynamic-variable/nsDynamicVariable";
import {ITextRange} from "../../../dynamic-variable/index";
import {getNextId} from "../../../../util/misc";
import {IFormPartParameters} from "./index";
import {ErrorTracker} from "../../../../error.tracker";
import {KOSubscriptionTracker} from "../../../../util/KOSubscriptionTracker";
import getTextRange = nsDynamicVariable.getTextRange;

export abstract class AbstractPart<TValue = unknown> {
    protected parameters: string[];
    protected textRange: ITextRange;
    protected readonly id: string = 'form-view-part-' + getNextId();
    protected readonly value: KnockoutObservable<TValue | null>;
    protected et: ErrorTracker;
    protected attr: { [key: string]: string | number | boolean };
    protected kosub = new KOSubscriptionTracker();

    constructor(protected params: IFormPartParameters) {
        this.id = params.id ?? this.id;
        this.attr = {id: this.id};
        this.value = params.value ?? ko.observable<TValue>(null);

        this.textRange = getTextRange(1, params.expression)!;
        this.parameters = nsForm.getParameters(this.textRange);

        this.et = params.errorTracker ?? new ErrorTracker();

        if (params.preview) {
            this.kosub.subscribe(this.value, () => this.isValid());
            this.isValid();
        }
    }

    protected getOptions(options: any[], selectedValue: any): any[] {
        const ret = options.map(o => {
            const tuple = o.split('§')
            const value = tuple[0];
            const text = tuple?.[1] ?? value;
            let selected: any = null;
            if (typeof selectedValue == 'string') {
                selected = selectedValue == value || selectedValue == text;
            }
            if (Array.isArray(selectedValue)) {
                selected = selectedValue.includes?.(value) || selectedValue.includes?.(text);
            }
            return {value, text, selected};
        });
        if (!ret.find(o => o.selected)) {
            const first = ret[0];
            if (first) {
                first.selected = true;
            }
        }
        return ret;
    }

    isValid(): boolean {
        return true;
    }

    public getSubmitData(): TValue | null {
        return this.value();
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }
}
